/**
 * 📦 COMPOSANT : sellerie-app/frontend/src\components\Devis\BandeauModeConserve.tsx
 * Ce composant est utilisé dans d'autres pages de l'application
 */

import React from 'react';

interface BandeauModeConserveProps {
  raison: string;
}

export const BandeauModeConserve: React.FC<BandeauModeConserveProps> = ({ raison }) => {
  return (
    <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg className="h-6 w-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-blue-800">
            📋 Devis en mode lecture seule
          </h3>
          <div className="mt-2 text-sm text-blue-700">
            <p>{raison}</p>
            <p className="mt-2">
              <strong>Actions disponibles :</strong> Visualisation et génération PDF uniquement
            </p>
            <p className="mt-1">
              <strong>Actions bloquées :</strong> Modification articles, ajout articles, remises, optimisation, finalisation
            </p>
            <p className="mt-2 text-xs italic">
              💡 Pour modifier ce devis, rechargez la page et choisissez "Dupliquer et recalculer" dans l'alerte
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
